import { type ReactNode } from "react";

export function StepHead({ step, title, sub, right }: { step: string; title: string; sub?: string; right?: ReactNode }) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div>
        <div className="flex items-baseline gap-3 mb-1.5">
          <h1 className="font-display font-extrabold tracking-tight text-[24px] leading-tight">{title}</h1>
        </div>
        {sub && <p className="text-ink-60 text-[14.5px] max-w-[640px] m-0">{sub}</p>}
      </div>
      {right}
    </div>
  );
}
